import moment from 'moment';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IModalSliceState } from './types';
import { IIncident } from '../../../pages/Incidents/interfaces';
import { IncidentsState } from '../../reducers/incidents';

const initialState: IModalSliceState = {
  type: '',
  data: '',
  id: '',
};

export default createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (draft, action: PayloadAction<IModalSliceState>) => {
      draft.type = action.payload.type;

      if (action.payload.data) {
        draft.data = action.payload.data;
      }

      if (action.payload.id) {
        draft.id = action.payload.id;
      }
    },
    closeModal: () => {
      return initialState;
    },

    // XXX KB-6251: this is a bit of a hack. We have an open modal (IncidentShowMoreModal) which in turn opens
    // a couple of Callouts, and the last Callout can edit the items displayed in the first modal,
    // which in turn come from the modal slice data (normally set before opening the modal) :/
    // This action allows us to update the first modal incidents data "in-place" when the Callout edits some incident.
    updateIncidentModalData: (
      draft,
      action: PayloadAction<{
        incident: IIncident;
        incidentTypes: IncidentsState['incidentTypes'];
      }>,
    ) => {
      const { incident, incidentTypes } = action.payload;
      const displayedDate = moment(draft.data.date);
      // Note that there is no option to create new or delete an incident while the modal is open.
      // And we only care about potential edit operations, where the edit can cause it to go out of range
      if (draft.data.incidents?.length > 0) {
        if (
          displayedDate.isBefore(incident.start) ||
          displayedDate.isAfter(incident.end)
        ) {
          // current date no longer within incident range, need to remove it from the modal data
          draft.data.incidents = draft.data.incidents.filter(
            (displayedIncident: IIncident) =>
              displayedIncident.id !== incident.id,
          );
        } else {
          // current date is still within the incident date range - update in-place
          const type = incidentTypes?.[incident?.type?.id];
          draft.data.incidents = draft.data.incidents.map(
            (displayedIncident: IIncident) =>
              displayedIncident.id === incident.id
                ? { ...incident, type }
                : displayedIncident,
          );
        }
      }
    },
  },
});
